import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
import { PRICING_GRID } from '../feature-row/feature-row-skeleton';
interface SectionHeaderSkeletonProps {
  hasToggle?: boolean;
  hasOneTimeFee?: boolean;
  oneTimeFeeSkeletonClassName?: string;
}

/** Skeleton for a section header (e.g., "Legal Setup", "Core Tools & Documentation") */
function SectionHeaderSkeleton(t0) {
  const $ = _c(12);
  const {
    hasToggle: t1,
    hasOneTimeFee: t2,
    oneTimeFeeSkeletonClassName
  } = t0;
  const hasToggle = t1 === undefined ? false : t1;
  const hasOneTimeFee = t2 === undefined ? false : t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("grid", PRICING_GRID.responsive, "items-center");
    t4 = cn("border-input bg-accent flex min-h-14 items-center gap-2 border-b px-4 lg:px-6", "sticky left-0 z-10 lg:static");
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] !== hasToggle) {
    t5 = <div className={t4}>{hasToggle ? <div className="flex items-center gap-2"><Skeleton className="bg-border h-5 w-9 rounded-full" /><Skeleton className="bg-border h-3.5 w-32" /><Skeleton className="bg-border h-5 w-16 rounded-md" /></div> : <div className="flex items-center gap-2"><Skeleton className="bg-border size-4 rounded-sm" /><Skeleton className="bg-border h-3.5 w-32" /><Skeleton className="bg-border h-5 w-16 rounded-md" /></div>}</div>;
    $[2] = hasToggle;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="border-input bg-accent flex h-full min-h-14 min-w-0 items-center justify-center border-b px-4 lg:hidden" />;
    t7 = Array.from({
      length: 4
    });
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== hasOneTimeFee || $[7] !== oneTimeFeeSkeletonClassName) {
    t8 = t7.map((_, i) => <div key={i} className={cn("border-input bg-accent hidden min-h-14 min-w-0 items-center border-b px-6 lg:flex", hasOneTimeFee && i === 3 ? "relative justify-end" : "justify-center")}>{hasOneTimeFee && i === 3 && <Skeleton className={cn("bg-border absolute right-6 h-3", oneTimeFeeSkeletonClassName ?? "w-16")} />}</div>);
    $[6] = hasOneTimeFee;
    $[7] = oneTimeFeeSkeletonClassName;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t5 || $[10] !== t8) {
    t9 = <div className={t3}>{t5}{t6}{t8}</div>;
    $[9] = t5;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}
export { SectionHeaderSkeleton };